var map = {
	"./abarth-logo.png": "3ce1",
	"./alfa-romeo-logo.png": "b5d4",
	"./citroen-logo.png": "a68e",
	"./ds-logo.png": "cb2e",
	"./fiat-logo.png": "2439",
	"./fiat-professional-logo.png": "4e23",
	"./jeep-logo.png": "fa9b",
	"./lancia-logo.png": "aa90",
	"./opel-logo.png": "0c04",
	"./peugeot-logo.png": "6178",
	"./spoticar-logo.png": "f6b0",
	"./vauxhall-logo.png": "a304"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "100c";